import { TeamMember, AboutContent } from '../types';

export const aboutContent: AboutContent = {
  heading: 'About AZ1.AI',
  description: 'Founded in 2024, AZ1.AI is at the forefront of agentic systems development, combining cutting-edge AI research with practical business applications.'
};

export const teamMembers: TeamMember[] = [
  {
    name: 'Hal Casteel',
    role: 'CEO/CTO',
    bio: 'With multiple decades of experience in healthcare, entrepreneurship, software, and IT, Hal combines deep technical expertise with strategic vision to lead AZ1.AI in developing next-generation agentic systems for enterprise applications.',
    image: '/images/team/hal-casteel.jpg',
  },
  {
    name: 'Matias Meirelles van Vliet',
    role: 'COO/CMO',
    bio: 'Impact-driven entrepreneur leading go-to-market strategy at AZ1. With experience co-founding startups across e-waste, craft brewing, and healthcare innovation, he bridges business strategy with global execution across the US, Europe, Africa, and Brazil.',
    image: '/images/team/matias-meirelles.jpg',
  },
];

export const coreValues: string[] = [
  'Excellence in AI system design and implementation',
  'Responsible development with human-centric focus',
  'Continuous innovation and research',
  'Transparent and ethical business practices',
  'Collaborative partnerships with clients',
];